import { Outlet } from "react-router-dom";
import { KycContext } from "../KycContext/KycContext";

export default function KycLayout() {
  return (
    <KycContext>
      <Outlet />
    </KycContext>
  );
}
